import { createApiRef } from '@backstage/core-plugin-api';

export type GithubOrgOption = {
  value: string;
  label: string;
  description?: string;
  metadata: {
    host: string;
    orgName: string;
  };
};

export type GithubOrgsResponse = {
  orgs: GithubOrgOption[];
  total: number;
  cached: boolean;
  timestamp: string;
};

export interface GithubOrgsApi {
  /**
   * Fetch GitHub organizations for a host.
   * @param host - GitHub host (e.g. github.com)
   * @param refresh - If true, bypass cache and fetch fresh data
   */
  getOrgs(host: string, refresh?: boolean): Promise<GithubOrgsResponse>;

  /**
   * Check whether a repository already exists in an organization (uncached).
   * @param host - GitHub host (e.g. github.com)
   * @param org - Organization login (e.g. carrier-digital)
   * @param repo - Repository name
   */
  repoExists(host: string, org: string, repo: string): Promise<boolean>;
}

export const githubOrgsApiRef = createApiRef<GithubOrgsApi>({
  id: 'plugin.github-orgs.service',
});
